import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getReportsStatuses, getReportStatusByName } from 'HELPERS/reports';
import { debounce } from 'HELPERS/utils';
import { Form, Radio } from 'antd';
import { fetchReportData, clearReportFilters } from 'ACTIONS/reports.actions';
import queryString from 'query-string';

import AccountSearch from 'COMPONENTS/DataGrid/AccountSearch';

const FormItem = Form.Item;

const allStatuses = getReportsStatuses();
const getStatuses = () => [
  {
    name: 'all',
    id: 'all',
    label: 'All',
    color: 'default',
  },
  {
    name: 'sent',
    id: allStatuses.find(status => status.name === 'sent').id,
    label: 'Sent',
  },
  {
    name: 'notSent',
    id: 'notSent',
    label: 'Not Sent',
  },
  {
    name: 'problem',
    id: allStatuses.find(status => status.name === 'problem').id,
    label: 'Problem',
  },
  {
    name: 'save',
    id: allStatuses.find(status => status.name === 'save').id,
    label: 'Save',
  },
];

class ReportsFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignStatus: this.getInitialStatusValue(),
      currentSearchValue: this.getInitialSearchValue(),
    };

    this.updateData = debounce(this.updateData, 300);
  }

  getInitialStatusValue = () => {
    const params = this.extractURLFilters();
    if (params.has('campaign_status_id')) {
      const current = params.get('campaign_status_id');
      return (current === 'all' || current === 'notSent') ? current : parseInt(current, 0);
    }
    // Default filter is problem.
    return getReportStatusByName('problem').id;
  }

  getInitialSearchValue = () => {
    const params = this.extractURLFilters();
    if (params.has('account_id')) {
      return {
        type: 'account_id',
        value: parseInt(params.get('account_id'), 0),
      };
    }
    if (params.has('client_id')) {
      return {
        type: 'client_id',
        value: parseInt(params.get('client_id'), 0),
      };
    }

    return null;
  }

  extractURLFilters = () => {
    const { location } = this.props.router;
    return new URLSearchParams(location.search);
  }

  updateResults = () => {
    const { location } = this.props.router;
    const queryParams = queryString.parse(location.search);
    const { campaignStatus, currentSearchValue } = this.state;
    const query = {
      ...queryParams,
      page: 1,
    };

    if (campaignStatus) {
      query.campaign_status_id = campaignStatus;
    }

    if (currentSearchValue) {
      query[`${currentSearchValue.type}_id`] = currentSearchValue.id;
    }

    this.props.fetchReportData(query);
  }

  handleSearch = (value) => {
    if (value === null) {
      this.props.clearReportFilters(['client_id', 'account_id']);
    }
    this.setState({ currentSearchValue: value }, () => this.updateResults());
  }

  handleSelectStatus = (e) => {
    const { value } = e.target;
    return this.setState({ campaignStatus: value }, () => {
      this.updateResults();
    });
  }

  render() {
    const statusList = getStatuses();

    return (
      <div className="filters-content">
        <div className="filter-item">
          <Form layout="inline">
            <FormItem>
              <Radio.Group value={this.state.campaignStatus} onChange={this.handleSelectStatus}>
                {statusList.map(status => (
                  <Radio.Button key={`filter_button_${status.name}`} value={status.id}>
                    {status.label}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </FormItem>
          </Form>
        </div>
        <div className="filter-item search">
          <AccountSearch
            onSelectValue={this.handleSearch}
            defaultValue={this.getInitialSearchValue()}
          />
        </div>
      </div>
    );
  }
}

ReportsFilters.defaultProps = {};
ReportsFilters.propTypes = {
  router: PropTypes.object.isRequired,
  fetchReportData: PropTypes.func.isRequired,
  clearReportFilters: PropTypes.func.isRequired,
};

const mapStateToProps = ({ reports, router }) => ({ ...reports, router });

export default connect(mapStateToProps, {
  fetchReportData,
  clearReportFilters,
})(ReportsFilters);



// WEBPACK FOOTER //
// ./src/pages/Reports/ReportsFilters/ReportsFilters.js